/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as ActionTypes from './ActionTypes';

const initialState = {
  proccessSearchResult: [],
  reportSearchResult: [],
  rebateProgram: '',
  rebateProgramList: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  selectedSearchType: 'NDC',
  rebateProgramValue: '',
  rebateProgramNameValue: '',
  errors: [],
  fromDateValue: '',
  selectedClass: 'ALL',
  selectedClassValue: '',
  therapeuticClassList: [],
  labelerSelectedRow: [],
  selectedNDC: [],
  ndcLeftTableData: [],
  labelerTableData: [],
  displayObj: {
    rebateProgramValue: '',
    fromDateValue: '',
    rebateProgramList: [],
    selectedClassValue: '',
    proccessSearchResult: [],
    reportSearchResult: [],
    rebateProgramName: '',
  },
};

const reducer = (state = initialState, Actions) => {
  switch (Actions.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: Actions.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_DRUGS_THERAPEUTIC_CLASS:
    // return { ...state, rebateProgramList: Actions.payload };

    case ActionTypes.DISPATCH_DRUGS_THERAPEUTIC_CLASS:
      return { ...state, therapeuticClassList: Actions.payload };
    case ActionTypes.DISPATCH_DRUGS_THERAPEUTIC_CLASS_PROCCESS:
      let displayObj = {
        ...state.displayObj,
        proccessSearchResult: Actions.payload,
      };
      return { ...state, proccessSearchResult: Actions.payload, displayObj };
    case ActionTypes.DISPATCH_DRUGS_THERAPEUTIC_CLASS_REPORT:
      let displayObj1 = {
        ...state.displayObj,
        reportSearchResult: Actions.payload,
      };
      return {
        ...state,
        reportSearchResult: Actions.payload,
        displayObj: displayObj1,
      };

    case ActionTypes.SET_SELECTED_INPUT:
      return { ...state, ...Actions.payload };
    case ActionTypes.REFRESH_DRUGS_THERAPEUTIC_CLASS:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.REFRESH_DRUGS_THERAPEUTIC_CLASS_DISPLAY:
      return {
        ...state,
        displayObj: state.displayObj,
      };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: Actions.isLoading };

    // case ActionTypes.GET_ERROR_MSG_NDC_DETAILS:
    //   return { ...state, errors: Actions.payload };

    default:
      return state;
  }
};

export default reducer;
